import getDocuments from "../form_functions/getDocuments";
import handlePartialSend from "./handlePartialSend";
import addReviewStyling from "../form_functions/addReviewStyling";

export default async (survey, options, config) => {
  const nextButton = document.querySelector("#sv-nav-next");
  if (options.question.name === "review_stage_pdfs") {
    if (nextButton) {
      nextButton.classList.add("hidden");
    }

    handlePartialSend(survey, config, true);
    getDocuments(config.urls.documents, config.requiredWaDocuments);

    const yesButton = document.querySelector("#yes-button");
    if (yesButton) {
      yesButton.addEventListener("click", () => {
        survey.nextPage();
      });
    }
  } else {
    if (nextButton) {
      nextButton.classList.remove("hidden");
    }
  }

  if (
    ["SA", "NSW", "QLD", "VIC", "ACT", "TAS"].includes(config.state) &&
    options.question.name == "ashes_delivery"
  ) {
    _updateAshesDelivery(survey);
  }

  if (options.question.name == "end_of_form_review") {
    addReviewStyling(survey);
  }

  Object.entries(config.defaultResponse).forEach(([name, val]) => {
    const question = survey.getQuestionByName(name);
    if (question) {
      question.defaultValue = val;
    }
  });
};

function _updateAshesDelivery(survey) {
  _setQuestionValueOnItem(
    survey,
    "ashes_delivery",
    "recipient_name_first",
    survey.data.applicant_name.first
  );
  _setQuestionValueOnItem(
    survey,
    "ashes_delivery",
    "recipient_name_last",
    survey.data.applicant_name.last
  );
  _setQuestionValueOnItem(survey, "ashes_delivery", "recipient_phone", survey.data.applicant_phone);
  _setQuestionValueOnItem(survey, "ashes_delivery", "street", survey.data.applicant_address.street);
  _setQuestionValueOnItem(survey, "ashes_delivery", "suburb", survey.data.applicant_address.suburb);
  _setQuestionValueOnItem(survey, "ashes_delivery", "state", survey.data.applicant_address.state);
  _setQuestionValueOnItem(
    survey,
    "ashes_delivery",
    "postcode",
    survey.data.applicant_address.postcode
  );
}

function _setQuestionValueOnItem(survey, parentName, questionName, value) {
  let question = null;
  let items = survey.getQuestionByName(parentName).items;
  if (items.length > 0) {
    question = items.find((i) => i.name == questionName);
    if (
      question &&
      (question.value === undefined || question.value === null || question.value === "")
    ) {
      question.value = value;
    }
  }
}
